exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.number .van-field__label{\r\n  width:1.2rem;\n}\n.number .van-cell:nth-child(1){\r\n  width:40vw !important;\n}\n.number .van-cell{\r\n  width:28vw !important;\r\n  overflow: auto;\n}\r\n", ""]);

// exports
